import { useEffect, useState } from 'react';
import { Question } from '../../../../interfaces';
import { useTrivia } from '../../../../hooks';
import { OptionQuestionTrivia } from './';
import { config } from '../../../../config';
import parse from 'html-react-parser'

type QuestionTriviaProps = {
  question: Question
  triviaId: number
}

export const QuestionTrivia = ({ question, triviaId }: QuestionTriviaProps) => {
  const [optionSelect, setOptionSelect] = useState<string | undefined>();
  const { selectResponseQuestion } = useTrivia();

  useEffect(() => {
    setOptionSelect(question.respuesta);
  }, [question.respuesta]);

  const selectOption = (optionId: string) => {
    setOptionSelect(optionId);
    selectResponseQuestion(question, optionId);
  }

  return (
    <div className="trivia" style={{ display: "flex", flexDirection: "column", maxHeight: "100%" }}>
      <h3 style={{fontSize: "25px"}} className="trivia__question">{parse(question.pregunta)}</h3>

      <figure className="trivia__image" style={{ display: question.img ? 'block' : 'none' }}>
        <img
          src={`${config.urlImgsTrivias}${Math.floor(triviaId / 100)}/${triviaId}/images/${question.img}`}
          className="trivia__image"
          alt={question.pregunta}
          style={{maxWidth: "300px", margin: "0 auto"}}
        />
      </figure>

      {/* Scrollable options */}
      <ul
        style={{
          listStyle: "none",
          padding: 0,
          margin: 0,
          flex: 1,
          overflowY: "auto",
          maxHeight: "400px",
          marginTop: "20px",
          marginBottom: "20px"
        }}
      >
        {question.opciones.map((option, i) => (
          <OptionQuestionTrivia
            key={option.id}
            option={option}
            selectOption={selectOption}
            isSelect={optionSelect === option.id}
            index={i}
          />
        ))}
      </ul>
    </div>
  )
}
